// SVG molecular network drifting behind the hero image.
// Uses brand primary + secondary only.
export default function MolecularBackground({ className = "" }) {
  return (
    <svg
      viewBox="0 0 500 600"
      xmlns="http://www.w3.org/2000/svg"
      className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="mol-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="hsl(206, 58%, 52%)" stopOpacity="0.35" />
          <stop offset="100%" stopColor="hsl(206, 58%, 52%)" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Connecting edges */}
      <g stroke="hsl(206, 58%, 52%)" strokeOpacity="0.35" strokeWidth="1">
        <line x1="80"  y1="120" x2="230" y2="220" />
        <line x1="230" y1="220" x2="380" y2="140" />
        <line x1="230" y1="220" x2="180" y2="410" />
        <line x1="180" y1="410" x2="360" y2="470" />
        <line x1="360" y1="470" x2="420" y2="290" />
        <line x1="420" y1="290" x2="380" y2="140" />
        <line x1="80"  y1="120" x2="180" y2="410" />
      </g>

      {/* Nodes */}
      <g className="molecule-node-a">
        <circle cx="80"  cy="120" r="14" fill="hsl(206, 58%, 52%)" fillOpacity="0.20" />
        <circle cx="80"  cy="120" r="6"  fill="hsl(206, 58%, 52%)" />
      </g>
      <g className="molecule-node-b">
        <circle cx="230" cy="220" r="18" fill="hsl(40, 55%, 55%)" fillOpacity="0.20" />
        <circle cx="230" cy="220" r="8"  fill="hsl(40, 55%, 55%)" />
      </g>
      <g className="molecule-node-a">
        <circle cx="380" cy="140" r="14" fill="hsl(206, 58%, 52%)" fillOpacity="0.20" />
        <circle cx="380" cy="140" r="6"  fill="hsl(206, 58%, 52%)" />
      </g>
      <g className="molecule-node-b">
        <circle cx="180" cy="410" r="14" fill="hsl(40, 55%, 55%)" fillOpacity="0.20" />
        <circle cx="180" cy="410" r="6"  fill="hsl(40, 55%, 55%)" />
      </g>
      <g className="molecule-node-a">
        <circle cx="360" cy="470" r="16" fill="hsl(206, 58%, 52%)" fillOpacity="0.20" />
        <circle cx="360" cy="470" r="7"  fill="hsl(206, 58%, 52%)" />
      </g>
      <g className="molecule-node-b">
        <circle cx="420" cy="290" r="14" fill="hsl(40, 55%, 55%)" fillOpacity="0.20" />
        <circle cx="420" cy="290" r="6"  fill="hsl(40, 55%, 55%)" />
      </g>

      {/* soft glow */}
      <circle cx="230" cy="220" r="140" fill="url(#mol-glow)" />
    </svg>
  );
}
